import { render, staticRenderFns } from "./uklon_market_seller.vue?vue&type=template&id=4308c2f5&scoped=true&"
import script from "./uklon_market_seller.vue?vue&type=script&lang=js&"
export * from "./uklon_market_seller.vue?vue&type=script&lang=js&"
import style0 from "./uklon_market_seller.vue?vue&type=style&index=0&id=4308c2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308c2f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4308c2f5')) {
      api.createRecord('4308c2f5', component.options)
    } else {
      api.reload('4308c2f5', component.options)
    }
    module.hot.accept("./uklon_market_seller.vue?vue&type=template&id=4308c2f5&scoped=true&", function () {
      api.rerender('4308c2f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uklon/location/tabs/uklon_market_seller.vue"
export default component.exports